import { render, staticRenderFns } from "./AuthorEventRegistration.vue?vue&type=template&id=5428cf10"
import script from "./AuthorEventRegistration.vue?vue&type=script&lang=js"
export * from "./AuthorEventRegistration.vue?vue&type=script&lang=js"
import style0 from "./AuthorEventRegistration.vue?vue&type=style&index=0&id=5428cf10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports